import { type FC, type ReactNode } from "react";

import { SectionLabel } from "./section_label";

const BLOCK = "[data-citations-to-check]";

// The chat's latest Citations to check, scrolled into view and lit for a
// second: lit at once, it fades back as `data-lit` comes off.
export const showLatestCitations = (chat: ParentNode) => {
  const block = [...chat.querySelectorAll<HTMLElement>(BLOCK)].at(-1);
  if (!block) return;
  block.scrollIntoView({ behavior: "smooth", block: "start" });
  block.toggleAttribute("data-lit", true);
  block.getBoundingClientRect();
  block.toggleAttribute("data-lit", false);
};

// Under a Drafting answer: what its sections cite from sources they don't
// read, one line each, then `action`. Muted, like the answer's notes. The
// Sections count shows it (see showLatestCitations).
export const CitationsToCheck: FC<{
  lines: ReadonlyArray<{ key: string; line: ReactNode }>;
  action?: ReactNode;
}> = ({ lines, action }) => (
  <div
    data-citations-to-check
    className="border-t border-slate-100 bg-slate-50 px-4 py-2 text-xs text-slate-600 transition-colors duration-1000 data-lit:bg-amber-100 data-lit:duration-0"
  >
    <SectionLabel size="xs">Citations to check</SectionLabel>
    <ul className="mt-1 space-y-0.5">
      {lines.map(({ key, line }) => (
        <li key={key}>{line}</li>
      ))}
    </ul>
    {action && <div className="mt-2">{action}</div>}
  </div>
);
